import React from "react";

import { useFormState } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { FieldErrorMessageProps } from "../types";

export function ErrorMessage(props: FieldErrorMessageProps) {
	const { t } = useTranslation();
	const { errors } = useFormState();

	const { customErrorMessage, customErrorClassName, addClassName } = props;

	let error = errors?.[props?.name];

	if (!error || error.message === undefined) {
		return null;
	}

	const customClass =
		customErrorClassName ||
		"message--validation field-validation-error" +
			(addClassName ? " " + addClassName : "");

	return (
		<div className={customClass}>
			<span>
				{customErrorMessage
					? t(customErrorMessage)
					: t(error.message.toString())}
			</span>
		</div>
	);
}
